import React from 'react';
import type {ProyectoDTO} from '../../../api/Objetos';
import {PageContainer, StatusBadge} from './projectUi';
import { useTranslation } from 'react-i18next';
import './projectWorkspace.css';
import {useProjectPublicView} from './projectForm.helpers';

export type ProjectFormSectionNavItem = {
    id: string;
    label: string;
};

export function ProjectFormLayout(props: {
    proyecto?: ProyectoDTO;
    sections: ProjectFormSectionNavItem[];
    children: React.ReactNode;
    onCancel?: () => void;
    onSubmit?: () => void;
    busy?: boolean;
    submitDisabled?: boolean;
    submitLabel?: string;
    readOnly?: boolean;
    onShowAll?: () => void;
}) {
    // 1. Instanciamos el hook de traducciones
    const { t } = useTranslation();
    const publicView = useProjectPublicView();

    const info = props.proyecto?.informacionGeneral;

    // 2. Traducimos los textos por defecto
    const projectName = info?.denominacion || t('projectHeader.newProject', 'Nuevo proyecto');
    const projectStatus = info?.estado || t('informacionGeneralSection.statusUndefined');

    const formatCurrency = (val?: number) =>
        new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency: 'EUR'
        }).format(val || 0);

    return (
        <PageContainer>
            <div className="projectPageHeader">
                <div className="projectPageHeaderMain">
                    <div className="projectPageTitleRow">
                        <h1 className="projectPageTitle">{projectName}</h1>
                        <StatusBadge label={projectStatus} tone="info"/>
                    </div>
                    {info && (<div className="projectPageSubHeader">

                        {/* 3. Reemplazamos los textos estáticos por t() */}
                        {!publicView && <span className="projectPageMetaItem">
                <strong>{t('projectHeader.ministryFile')}</strong> {info.numeroExpedienteMinisterio || '-'}
              </span>}
                        {!publicView && <span className="projectPageMetaItem">
                <strong>{t('projectHeader.cityHallFile')}</strong> {info.numeroExpedienteAyuntamiento || '-'}
              </span>}
                        <span className="projectPageMetaItem">
                <strong>{t('projectHeader.totalAmount')}</strong> {formatCurrency(info.importeTotal)}
              </span>
                        {!publicView && <span className="projectPageMetaItem">
                <strong>{t('projectHeader.municipalContribution')}</strong> {formatCurrency(info.aportacionMunicipal)}
              </span>}
                        <span className="projectPageMetaItem">
                <strong>{t('projectHeader.subsidizedAmount')}</strong> {formatCurrency(info.importeSubvencionado)}
              </span>
                    </div>)}
                </div>

                <div className="projectPageActions">


                    {!props.readOnly && (props.onCancel || props.onSubmit) && (
                        <>
                            {props.onCancel && (
                                <button className="btn btnSecondary" type="button" onClick={props.onCancel}>
                                    {t('adminProjectCreate.cancel')}
                                </button>
                            )}

                            {props.onSubmit ? (
                                <button
                                    className="btn btnPrimary"
                                    type="button"
                                    onClick={props.onSubmit}
                                    disabled={props.busy || props.submitDisabled}>
                                    {props.busy ? t('sectionCrudUtils.saving') : props.submitLabel ?? t('sectionCrudUtils.saveSection')}
                                </button>
                            ) : null}
                        </>
                    )}

                </div>

            </div>

            <div className="projectPageBody">
                {props.children}
            </div>

        </PageContainer>
    );
}
